<template>
  <span
    class="badge rounded-pill text-bg-secondary"
    v-if="state === 'false'"
  >
    User
  </span>
  <span
    class="badge rounded-pill text-bg-primary text-white"
    v-else-if="state === 'superadmin'"
  >
    Superadmin
  </span>
  <span
    :class="'badge rounded-pill ' + (!isDark ? 'text-bg-dark' : 'text-bg-light')"
    v-else-if="state === 'admin'"
  >
    Admin
  </span>
  <span v-else>
    <BeatLoader
      :color="'rgba(64, 137, 201, 1)'"
      :size="'10px'"
      class="mt-1"
    />
  </span>
</template>

<script>
  import BeatLoader from "vue-spinner/src/BeatLoader.vue";
  import {useDark} from "@vueuse/core";
  
  export default {
    name: "StateLabel",
    components: {
      BeatLoader,
    },
    props: {
      state: String,
    },
    setup() {
      const isDark = useDark();
      return {isDark};
    },
  };
</script>
